import { Action, createReducer, on } from '@ngrx/store';
import { VendorServiceCharges, VendorServiceChargesSuccess, VendorServiceChargesFailure, fetchClientServiceCharges, fetchClientServiceChargesSuccess, fetchClientServiceChargesFailure, fetchVendorServiceCharges, fetchVendorServiceChargesFailure, fetchVendorServiceChargesSuccess } from "./servicecharges.actions";

export interface ServiceChargesState {
    loading: boolean;
    error: any;
    success: boolean;
    servicecharges: any;
    vendorservicecharges: any;
    clientservicecharges: any;
}

export const initialState: ServiceChargesState = {
    loading: false,
    error: null,
    success: false,
    servicecharges: null,
    vendorservicecharges: null,
    clientservicecharges: null
};

export const ServiceChargesReducer = createReducer(
    initialState,

    on(VendorServiceCharges, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(VendorServiceChargesSuccess, (state) => {
        return { ...state, success:true, loading: false };
    }),
    on(VendorServiceChargesFailure, (state, { error }) => {
        return { ...state, error,  success:false, loading: false };
    }),

    on(fetchClientServiceCharges, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchClientServiceChargesSuccess, (state, { servicecharges }) => {
        return { ...state, success:true, loading: false, clientservicecharges: servicecharges };
    }),
    on(fetchClientServiceChargesFailure, (state, { error }) => {
        return { ...state, error,  success:false, loading: false };
    }),

    on(fetchVendorServiceCharges, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchVendorServiceChargesSuccess, (state, { servicecharges }) => {
        return { ...state, success:true, loading: false, vendorservicecharges: servicecharges };
    }),
    on(fetchVendorServiceChargesFailure, (state, { error }) => {
        return { ...state, error,  success:false, loading: false };
    }),
);

// Selector
export function reducer(state: ServiceChargesState | undefined, action: Action) {
    return ServiceChargesReducer(state, action);
}
